// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dVKAp","message":"styles_message__7nstk","form":"styles_form__iRq+w"};